import { useQuery } from '@tanstack/react-query'

import axiosInstance from '@/libs/configs/axios'
import { TApiResult, TLinkedPartner, TPayoutInfo } from '@/libs/types/global.types'

export const USER_PROFILE_KEY = 'profile'

export type TUserData = {
  id: string
  fullName: string
  email: string
  phoneNumber: string
  payoutInfo: TPayoutInfo[]
  isFinishedOnboarding: boolean
  partnerId: string
  linked: TLinkedPartner[]
  partnerName: string | null
  emailVerified: boolean
}

export const getDetailProfile = () => {
  const axiosConfig = {
    baseURL: process.env.NEXT_PUBLIC_API_URL,
    url: `/user/profile`,
    method: 'get',
  }

  return axiosInstance<TApiResult<TUserData>>(axiosConfig)
}

const useSuspenseGetDetailProfile = (params: { enabled: boolean } = { enabled: false }) => {
  return useQuery({
    queryKey: [USER_PROFILE_KEY],
    queryFn: () => getDetailProfile(),
    enabled: params?.enabled,
    staleTime: 0,
  })
}

export default useSuspenseGetDetailProfile
